import  usePartnerOpen from './usePartnerOpen';
export default usePartnerOpen
